import { EventEmitter } from "pixi.js";


export enum EnumEventBus {
	rotateChords = "ROTATE_CHORDS",
	moveChordA = "MOVE_CHORD_A",
	moveChordB = "MOVE_CHORD_B",
	setPointChecklist = "SET_POINT_CHECK_LIST"
}


export const eventBus = new EventEmitter();